import axios from 'axios'
import { getEndpoint } from '../../../features/common/backend/endpoints'

export const generateExcel = async (fromDate, toDate) => {
  const endpoint = getEndpoint('QUOTES')
  const url = `${endpoint}/quotes/generateExcel?from=${fromDate}&to=${toDate}`

  const res = await axios(url, {
    method: 'GET',
    timeout: 300000, // 5 minutos
  })

  return res.data
}
